export default "__VITE_ASSET__CyJ45lvI__"